import { useEffect, useState } from 'react';
import { NumbersSize } from '../components/EditorialNumbers';

export const useNumbersSize = () => {
  const [size, setSize] = useState<NumbersSize>(NumbersSize.LARGE);

  const handleResize = () => {
    const width = window.innerWidth;

    if (width <= 768) {
      setSize(NumbersSize.SMALL);
    } else if (width <= 1024) {
      setSize(NumbersSize.MEDIUM);
    } else {
      setSize(NumbersSize.LARGE);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return size;
};
